<template>
  <div class="account_menu_main_w">
    <div class="head fz12 c_1A1A1A d_flex justify_content_sb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>我的账户</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/account/setting' }"
        >账户设置</el-breadcrumb-item>
        <el-breadcrumb-item>手机号码更换</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content_w">
      <el-steps v-if="currentStep !== 3" :active="currentStep" align-center>
        <el-step title="验证身份">
          <div slot="icon" class="c_fff">1</div>
        </el-step>
        <el-step title="绑定新手机号码">
          <div slot="icon">2</div>
        </el-step>
        <el-step title="完成更换">
          <div slot="icon">3</div>
        </el-step>
      </el-steps>

      <!-- 步骤1 -->
      <div v-if="currentStep === 1">
        <div v-if="isLogin" class="div_4">
          <div class="fz16 c_1A1A1A text_center">
            已绑定手机号：{{ userinfo.phone }}
          </div>
          <div class="fz12 c_ccc text_center div_3">
            若该号码无法使用，请联系官方客服
          </div>
        </div>

        <el-form
          ref="stepForm_1"
          :model="stepForm_1"
          :rules="rules"
          class="form_1"
        >
          <el-form-item prop="smscode">
            <el-input v-model="stepForm_1.smscode" :maxlength="input_l_150" placeholder="请输入验证码">
              <template slot="prepend">验证码：</template>
            </el-input>
            <div
              :class="
                countDown < 60 || !userinfo.phone
                  ? 'disabled_btn send_vcode_btn'
                  : 'send_vcode_btn is_active'
              "
              @click="onSendVcodeClick"
            >
              <span v-if="countDown === 60">获取验证码</span>
              <span v-else>{{ countDown }}s后重新获取</span>
            </div>
          </el-form-item>
        </el-form>
        <div
          class="div_6 c_fff bc_0983CC text_center cursor_pointer"
          @click="onNextClick('stepForm_1')"
        >
          下一步
        </div>
      </div>
      <!-- 步骤2 -->
      <div v-if="currentStep === 2">
        <el-form
          ref="stepForm_2"
          :model="stepForm_2"
          :rules="rules_2"
          class="form_2"
          @validate="onValidateForm"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="stepForm_2.phone"
              placeholder="建议使用常用手机号"
              @blur="onPhoneBlur"
            >
              <template slot="prepend">手机号：</template>
            </el-input>
          </el-form-item>

          <el-form-item prop="smscode">
            <el-input v-model="stepForm_2.smscode" :maxlength="input_l_150" placeholder="短信验证码">
              <template slot="prepend">验证码：</template>
            </el-input>
            <div
              :class="
                countDown < 60 || !passPhone
                  ? 'disabled_btn send_vcode_btn'
                  : 'send_vcode_btn is_active'
              "
              @click="onSendVcodeClick"
            >
              <span v-if="countDown === 60">获取验证码</span>
              <span v-else>{{ countDown }}s后重新获取</span>
            </div>
          </el-form-item>
        </el-form>

        <div
          class="div_6 c_fff bc_0983CC text_center cursor_pointer"
          @click="onSubmitClick('stepForm_2')"
        >
          提交
        </div>
      </div>
      <!-- 步骤3 -->
      <div
        v-if="currentStep === 3"
        class="d_flex align_item_c flex_direction_col"
      >
        <img src="@/assets/images/s_success_icon.png" alt="">
        <div class="fz20 c_1A1A1A div_5 text_center">修改成功</div>
        <span class="fz14 c_808080">{{ countDown }}秒后自动跳转</span>
      </div>
    </div>
  </div>
</template>

<script>
import { user_gee_web_init } from '@/api/public'
import { mapGetters, mapActions } from 'vuex'
import { user_modifyPhone, user_authPhone, user_checkPhone } from '@/api/user'
import { user_sms_authPhone, user_sms_modifyPhone } from '@/api/sms'
import { isvalidPhone } from '@/utils'
import {
  _input_l_150,
  _input_l_300,
  _input_l_500 } from '@/utils/setting'
export default {
  data() {
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else if (!isvalidPhone(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else if (this.isAlreadyPhone) {
        callback(new Error('手机号已存在'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        smscode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },

      rules_2: {
        phone: [{ required: true, trigger: 'change', validator: validPhone }],
        smscode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      currentStep: 1,
      stepForm_1: {},
      stepForm_2: {},

      countDown: 60,
      countDownTimer: null,

      passPhone: false,
      isAlreadyPhone: false
    }
  },
  computed: {
    ...mapGetters(['userinfo', 'isLogin']),
    input_l_150() {
      return _input_l_150
    },
    input_l_300() {
      return _input_l_300
    },
    input_l_500() {
      return _input_l_500
    }
  },
  watch: {
    currentStep: function(n, o) {
      this.countDownTimer && clearInterval(this.countDownTimer)
      this.countDown = 60
      if (n <= 0) {
        this.currentStep = 1
      }
      if (n > 3) {
        this.currentStep = 3
      }

      if (n === 3) {
        this.countDown = 3
        this.countDownTimer = setInterval(() => {
          this.countDown--
          if (this.countDown <= 0) {
            this.countDown = 0
            clearInterval(this.countDownTimer)
          }
        }, 1000)
      }
    }
  },
  methods: {
    ...mapActions({
      doLogout: 'user/doLogout'
    }),
    // 下一步 click
    onNextClick(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const res = await user_authPhone(this.stepForm_1) // 验证身份 api
          if (res.code === 200) {
            this.stepForm_2.token = res.data
            this.currentStep++
          }
        }
      })
    },

    // 发送验证码 click
    async onSendVcodeClick() {
      if (this.currentStep === 1) {
        if (this.countDown < 60 || !this.userinfo.phone) return
      } else if (this.currentStep === 2) {
        if (this.countDown < 60 || !this.passPhone) return
      }

      const { data } = await user_gee_web_init()

      await initGeetest(
        {
          // 以下配置参数来自服务端 SDK
          gt: data.gt,
          challenge: data.challenge,
          offline: !data.success,
          new_captcha: true,
          product: 'bind'
        },
        (captchaObj) => {
          captchaObj
            .onReady(() => {
              captchaObj.verify() // 显示验证码
            })
            .onSuccess(() => {
              this.sendValidCode(captchaObj.getValidate(), data)
            })
            .onError(() => {})
        }
      )
    },

    // 发送验证码 api
    async sendValidCode(validDate, firstValidRes) {
      const validConfig = {
        ...validDate,
        geeuser: firstValidRes.geeuser
      }
      let res = {}

      if (this.currentStep === 1) {
        validConfig.phone = this.userinfo.phone
        res = await user_sms_authPhone(validConfig)
      } else if (this.currentStep === 2) {
        validConfig.phone = this.stepForm_2.phone
        res = await user_sms_modifyPhone(validConfig)
      }

      if (res.code === 200) {
        this.countDownTimer = setInterval(() => {
          this.countDown--
          if (this.countDown < 1) {
            this.countDown = 60
            clearInterval(this.countDownTimer)
          }
        }, 1000)
      }
    },
    // 提交 click
    onSubmitClick(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const res = await user_modifyPhone(this.stepForm_2)
          if (res.code === 200) {
            this.currentStep++
            setTimeout(() => {
              this.$notify({
                type: 'warning',
                message: '登录失效，请重新登录！',
                duration: 5000
              })
              this.doLogout('/')
            }, 3000)
          }
        }
      })
    },
    // 触发表单校验时
    onValidateForm(prop, isValid, err) {
      if (prop === 'phone') {
        this.passPhone = isValid
      }
    },
    // 手机号失去焦点
    onPhoneBlur() {
      if (!this.stepForm_2.phone || !isvalidPhone(this.stepForm_2.phone)) return

      this.checkPhone()
    },
    // 校验手机号 api
    async checkPhone() {
      try {
        const res = await user_checkPhone({
          phone: this.stepForm_2.phone
        }, {
          noPrint: true
        })
        if (res.code === 200) {
          this.isAlreadyPhone = false
        }
      } catch (err) {
        this.isAlreadyPhone = true
      }
      this.$refs.stepForm_2.validateField('phone')
    }
  }
}
</script>

<style lang="scss" scoped>
.account_menu_main_w {
  width: 970px;
  height: 667px;
  box-sizing: border-box;
  border: 1px solid #dbdbdb;
  box-shadow: 0px 2px 6px 0px rgba(204, 204, 204, 0.6);
  .head {
    padding: 19px 20px;
    background: #e6e6e6;
  }

  .div_2 {
    margin: 25px 0 0 0;
  }
  .div_3 {
    margin: 4px 0 0 0;
  }
  .div_4 {
    margin: 20px 0;
    padding: 13px 0;
    border: 1px solid #e6e6e6;
  }
  .div_5 {
    margin: 20px auto;
  }
  .div_6 {
    width: 353px;
    height: 54px;
    line-height: 54px;
    margin: 35px auto 0 auto;
  }
  .send_vcode_btn {
    display: inline-block;
    width: 149px;
    background: #0983cc;
    color: #fff;
    padding: 10px 0;
    text-align: center;
    margin: 0 0 0 13px;
    font-size: 16px;
    cursor: pointer;
  }
  .form_2 {
    margin: 20px 0 0 0;
  }

  ::v-deep .el-form-item__content {
    display: flex;
  }
  ::v-deep .el-form-item__label {
    font-size: 16px;
    line-height: 60px;
    color: #1a1a1a;
  }
  ::v-deep .form_1,
  ::v-deep .form_2 {
    & .el-input__inner {
      border-left: 0;
      padding-left: 0;
    }
  }
  ::v-deep .el-input__inner {
    height: 60px;
    line-height: 60px;
    border: 1px solid #e6e6e6;
    ::-webkit-input-placeholder {
      /* Chrome/Safari/Opera */
      font-size: 16px;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      font-size: 16px;
    }
    // :-ms-input-placeholder {
    //   /* IE 10+ 注意这里只有一个冒号 */
    //   font-size: 16px;
    // }
  }
  ::v-deep .el-form-item.is-error .el-input__inner {
    border-color: #e6e6e6;
  }
  ::v-deep .el-input-group--prepend {
    flex: 1;
  }
  ::v-deep .el-input-group__prepend {
    background-color: #fff;
    padding-right: 0;
    border-radius: 0;
    padding-left: 11px;
    color: #1a1a1a;
    font-size: 15px;
  }
  ::v-deep .el-input__prefix {
    left: 10px;
    top: 2px;
  }

  // 步骤条
  ::v-deep .el-step__main {
    .is-finish {
      color: #6db6fc;
    }
  }
  ::v-deep .is-finish .el-step__icon {
    background: #2caeff;
  }
  ::v-deep .el-step {
    &:first-child {
      .el-step__head,
      .el-step__main {
        text-align: left;
      }
    }
  }
  ::v-deep .el-step {
    &:last-child {
      .el-step__head,
      .el-step__main {
        text-align: right;
      }
    }
  }
  ::v-deep .el-step .el-step__line {
    height: 1px;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #e6e6e6;
  }
  ::v-deep .el-step__icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 1px solid #e6e6e6;
    font-size: 30px;
  }
  ::v-deep .el-step__title {
    font-size: 14px;
  }
  ::v-deep .is-finish > .el-step__icon {
    color: #fff;
    background-color: #6db6fc;
  }
  ::v-deep .is-process,
  .is-wait {
    color: #999;
  }
}
.content_w {
  width: 476px;
  margin: 85px auto 0 auto;
}
</style>
